import { motion } from "framer-motion";
import { LogIn, LogOut, Zap } from "lucide-react";

export default function Nav({ t, locale, setLocale, onCta, user, onLogin, onLogout }) {
  return (
    <motion.header
      data-testid="main-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-black/10 bg-white/70 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5">
          <img src="/logo-mark.png" alt="Logo Syncroo" className="h-8 w-8 object-contain" />
          <span className="font-display text-lg font-black uppercase tracking-tight text-flame">
            Syncroo
          </span>
        </a>

        <div
          data-testid="language-switcher"
          className="flex items-center gap-2 font-display text-sm font-bold uppercase tracking-widest"
        >
          <button
            data-testid="lang-it-btn"
            onClick={() => setLocale("it")}
            className={`transition-colors duration-300 ${
              locale === "it" ? "text-bone" : "text-ash hover:text-bone"
            }`}
          >
            IT
          </button>
          <span className="text-ash/40">/</span>
          <button
            data-testid="lang-en-btn"
            onClick={() => setLocale("en")}
            className={`transition-colors duration-300 ${
              locale === "en" ? "text-bone" : "text-ash hover:text-bone"
            }`}
          >
            EN
          </button>
        </div>

        <div className="flex items-center gap-3 sm:gap-4">
          {user ? (
            <div className="flex items-center gap-3">
              <img
                src={user.picture || "/logo-mark.png"}
                alt={user.name || "Utente"}
                data-testid="nav-user-avatar"
                className="h-9 w-9 rounded-full border border-black/10 object-cover"
                referrerPolicy="no-referrer"
              />
              {user.is_admin && (
                <a
                  href="/admin"
                  data-testid="nav-admin-link"
                  className="inline-flex items-center font-display text-xs font-bold uppercase tracking-widest text-ash transition-colors duration-300 hover:text-flame"
                >
                  {t.admin}
                </a>
              )}
              <button
                data-testid="nav-logout-btn"
                onClick={onLogout}
                className="inline-flex items-center gap-1.5 font-display text-xs font-bold uppercase tracking-widest text-ash transition-colors duration-300 hover:text-flame"
              >
                <LogOut size={14} />
                <span className="hidden sm:inline">{t.logout}</span>
              </button>
            </div>
          ) : (
            <button
              data-testid="nav-login-btn"
              onClick={onLogin}
              className="inline-flex items-center gap-1.5 font-display text-xs font-bold uppercase tracking-widest text-ash transition-colors duration-300 hover:text-flame"
            >
              <LogIn size={14} />
              {t.login}
            </button>
          )}
          <motion.button
            data-testid="nav-waitlist-cta"
            onClick={onCta}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.96 }}
            className="hidden items-center gap-2 rounded-full bg-flame px-5 py-2.5 font-display text-sm font-bold uppercase tracking-wide text-white transition-colors duration-300 hover:bg-flame-hover sm:inline-flex"
          >
            <Zap size={14} strokeWidth={2.5} />
            {t.cta}
          </motion.button>
        </div>
      </div>
    </motion.header>
  );
}
